// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"TableCellToggle-primaryButton-3vL9OI","disableLabel":"TableCellToggle-disableLabel-3ONUAy"};